export default __webpack_public_path__ + "static/media/privacy.936ee7d2.jpg";